module.exports = __webpack_public_path__ + "static/logo-1a76745c9c7d84daff25395ad86f2c55.png";